module.exports = __webpack_public_path__ + "img/full0-min.c347020d.png";